/**
 * Private Key patterns:
 *
 * Detects various types of private keys including RSA, DSA, EC, and SSH keys.
 * These keys are typically in PEM format and should never be committed to source code.
 *
 * Patterns:
 * 1. RSA Private Key:
 *    - Starts with -----BEGIN RSA PRIVATE KEY-----
 *    - Ends with -----END RSA PRIVATE KEY-----
 *
 * 2. Private Key (generic):
 *    - Starts with -----BEGIN PRIVATE KEY-----
 *    - Ends with -----END PRIVATE KEY-----
 *
 * 3. EC Private Key:
 *    - Starts with -----BEGIN EC PRIVATE KEY-----
 *    - Ends with -----END EC PRIVATE KEY-----
 *
 * 4. DSA Private Key:
 *    - Starts with -----BEGIN DSA PRIVATE KEY-----
 *    - Ends with -----END DSA PRIVATE KEY-----
 *
 * 5. OpenSSH Private Key:
 *    - Starts with -----BEGIN OPENSSH PRIVATE KEY-----
 *    - Ends with -----END OPENSSH PRIVATE KEY-----
 *
 * 6. PGP Private Key Block:
 *    - Starts with -----BEGIN PGP PRIVATE KEY BLOCK-----
 *    - Ends with -----END PGP PRIVATE KEY BLOCK-----
 *
 * Examples:
 * ```
 * -----BEGIN RSA PRIVATE KEY-----
 * MIIEpAIBAAKCAQEA...
 * -----END RSA PRIVATE KEY-----
 * ```
 *
 * References:
 * - https://github.com/secretlint/secretlint/blob/master/packages/%40secretlint/secretlint-rule-privatekey/src/index.ts
 * - https://en.wikipedia.org/wiki/Privacy-Enhanced_Mail
 * - https://www.rfc-editor.org/rfc/rfc7468
 */

export const rsaPrivateKey =
  /-----BEGIN RSA PRIVATE KEY-----[\s\S]*?-----END RSA PRIVATE KEY-----/;
export const privateKey =
  /-----BEGIN PRIVATE KEY-----[\s\S]*?-----END PRIVATE KEY-----/;
export const ecPrivateKey =
  /-----BEGIN EC PRIVATE KEY-----[\s\S]*?-----END EC PRIVATE KEY-----/;
export const dsaPrivateKey =
  /-----BEGIN DSA PRIVATE KEY-----[\s\S]*?-----END DSA PRIVATE KEY-----/;
export const opensshPrivateKey =
  /-----BEGIN OPENSSH PRIVATE KEY-----[\s\S]*?-----END OPENSSH PRIVATE KEY-----/;
export const pgpPrivateKey =
  /-----BEGIN PGP PRIVATE KEY BLOCK-----[\s\S]*?-----END PGP PRIVATE KEY BLOCK-----/;
export const encryptedPrivateKey =
  /-----BEGIN ENCRYPTED PRIVATE KEY-----[\s\S]*?-----END ENCRYPTED PRIVATE KEY-----/;
